<div class="wallpaper">
  <img src="assets/images/wallpaper.jpg" alt="Summa wallpaper" />
</div>

<div class="login-container" fxLayout="column" fxLayoutAlign="center center">
  <summa-login-form
    [title]="'Portal'"
    [error]="sandbox.error$ | async"
    [loading]="sandbox.isLoading$ | async"
    (login)="login$.next($event)">
  </summa-login-form>
</div>
